/**
 * How a job's status reads.
 *
 * Jobs have their own status set — PLANNED through CANCELLED — which the shared
 * StatusBadge does not cover, so the colours live here rather than being spelled
 * out on both the list and the job's own page.
 */
export const JOB_STATUS_TONE: Record<string, string> = {
  PLANNED: 'bg-status-info-subtle text-status-info-foreground',
  ACTIVE: 'bg-status-success-subtle text-status-success-foreground',
  SUSPENDED: 'bg-status-warning-subtle text-status-warning-foreground',
  COMPLETED: 'bg-status-neutral-subtle text-status-neutral-foreground',
  CANCELLED: 'bg-status-destructive-subtle text-status-destructive-foreground',
};
